/**
 * Scroll-based rotation for floating product images (e.g. can, belt bag).
 * Rotates the image as the user scrolls up or down the page.
 */
class ScrollRotateImage extends HTMLElement {
  #rafId = null;

  connectedCallback() {
    window.addEventListener('scroll', this.#onScroll, { passive: true });
    window.addEventListener('resize', this.#onScroll);
    this.#updateRotation();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#onScroll);
    window.removeEventListener('resize', this.#onScroll);
    if (this.#rafId != null) {
      cancelAnimationFrame(this.#rafId);
      this.#rafId = null;
    }
  }

  #onScroll = () => {
    if (this.#rafId != null) return;
    this.#rafId = requestAnimationFrame(() => {
      this.#rafId = null;
      this.#updateRotation();
    });
  };

  #updateRotation() {
    const img = this.querySelector('img');
    if (!img) return;

    const twirlCount = Number(this.dataset.twirlCount ?? 3);
    const scrollRange = Number(this.dataset.scrollRange ?? 600);

    const scrollY = window.scrollY;
    const section = this.closest('.shopify-section');
    const scrollStart = section
      ? section.offsetTop - window.innerHeight + 200
      : 0;

    // Map scroll to twirls: image spins in place (0 to N full 360° rotations), 50% slower
    const scrollProgress = scrollY - scrollStart;
    const progress = Math.max(0, Math.min(1, scrollProgress / (scrollRange * 1.5)));
    const rotation = progress * twirlCount * 360;

    img.style.transform = `rotate(${rotation}deg)`;
  }
}

if (!customElements.get('scroll-rotate-image')) {
  customElements.define('scroll-rotate-image', ScrollRotateImage);
}
